<template>
  <div class="contract-body">

    <!-- 搜索 -->
    <div class="search-wrap">
      <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001005001)" @click="edit()" icon="el-icon-plus">添加合作伙伴</el-button>
      <el-button size="mini" type="primary" @click="getList()">刷新</el-button>
      <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001005004)" @click="exportExcel">导出</el-button>
      <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001005004)" @click="importExcel">导入</el-button>

      <!-- <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="search()" :loading="searchLoading">搜索</el-button> -->
    </div>

    <!-- 区域树 -->
    <div class="area-wrap">
      <el-tree :props="props" :load="loadNode" :data="data" node-key="id" :empty-text="emptyText" lazy :highlight-current="true" :default-expanded-keys="defExpKeys" @node-expand="nodeExpand" @node-collapse="nodeCollapse">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div class="area-info">{{ node.label }}</div>
          <div class="area-opt">
            <el-tag size="mini" v-if="ERP.isPermission(26005001005001)" @click="(e) => edit(e, {parent_id: data.id,abbreviation:data.abbreviation})"><i class="el-icon-plus"></i>添加</el-tag>
            <el-tag size="mini" v-if="ERP.isPermission(26005001005002)" @click="(e) => edit(e, data)"><i class="el-icon-edit"></i>编辑</el-tag>
            <el-tag type="danger" v-if="ERP.isPermission(26005001005003)" size="mini" @click="(e) => remove(e, data)"><i class="el-icon-delete"></i>删除</el-tag>
          </div>
        </div>
      </el-tree>
    </div>

    <!-- 添加窗口 -->
    <el-dialog title="添加简称/合作企业" :visible.sync="dialogVisible" :close-on-click-modal="true" class="area-dialog" width="600px">

      <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="mini" class="area-form">
        <el-form-item label="合作企业" prop="name">
          <el-input v-model="form.name" placeholder="请填写企业名称"></el-input>
        </el-form-item>
        <el-form-item label="上级" prop="parent_name">
          <div style="display: flex;">
            <el-input v-model="form.parent_name" readonly placeholder="留空时为大区域"></el-input>
            <el-button type="primary" style="margin-left: 5px;" @click="showSelector()">选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="简称" prop="abbreviation">
          <el-input v-model="form.abbreviation" placeholder="请填写简称"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="submitLoading">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <PartnershipSelector :visible.sync="areaSelectorVisible" @selected="areaSelected"></PartnershipSelector>

  </div>
</template>

<script>

  import PartnershipSelector from './PartnershipSelector.vue'
  import { Partnership } from './common.js'
  import CommonHelp from "./common/CommonHelp";

export default {
  name:"ContractPartnership",
  components: {
    PartnershipSelector
  },
  data () {
    return {
      host_url:null,
      keyword: '',
      searchLoading: false,
      submitLoading: false,
      dialogVisible: false,
      areaSelectorVisible: false,
      form: {},
      defValue: {
        id: '',
        parent_id: '',
        parent_name: '-',
        name: '',
        abbreviation: '',
        remark: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入区域名称。', trigger: 'blur' },
        ],
      },

      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      data: [],
      emptyText: '',
      defEmptyText: '暂无数据',
      defExpKeys: [],
    }
  },
  beforeMount() {
    this.resetForm()
  },
  watch: {
    // dialogVisible(val) {
    //   if(val == false) {
    //     this.resetForm()
    //   }
    // }
  },
  created() {
    this.getList()
    this.host_url=CommonHelp.getBaseURL();
  },
  methods: {
    search() {

    },
    getList() {
      this.emptyText = '正在加载数据...'
      Partnership.getList({parent_id: 0}, res => {
        this.emptyText = this.defEmptyText
        this.data = res.data
      })
    },
    edit(e, data) {

      if(data) {
        this.form = Object.assign({}, this.defValue, data)
        this.getFullName()
      } else {
        this.resetForm()
      }

      this.dialogVisible = true
      if(e) e.stopPropagation()
    },
    remove(e, data) {

      this.$confirm(`此操作将删除 [ ${data.name} ] 及其子区域，是否继续?`, '提示', {type: 'warning'}).then(() => {
        Partnership.delete({id: data.id}, res => {
          this.message(res)
          if(res.code == 0) this.getList()
        })
      })

      e.stopPropagation()
    },
    submit() {

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          return false;
        }
      });

    },
    resetForm() {
      this.form = Object.assign({}, this.defValue)
    },
    save() {

      this.submitLoading = true
      let data = Object.assign({}, this.form)
      Partnership.save(data, res => {
        this.submitLoading = false
        this.message(res)
        if(res.code == 0) {
          this.resetForm()
          this.dialogVisible = false
          this.getList()
        }
      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },

    showSelector() {
      this.areaSelectorVisible = true
    },

    areaSelected(data) {

      if(data.id == this.form.id) {
         this.$message.error('上级不能选择自己')
         return false
      }

      this.form.parent_id = data.id
      this.form.abbreviation = data.abbreviation
      this.getFullName()
    },

    getFullName() {
      let that = this
      if(that.form.parent_id == '') return false
      Partnership.getFullName({id: that.form.parent_id}, res => {

        that.form = Object.assign({}, that.form, {
          parent_name: res.data.join(' -> '),
          abbreviation:that.form.abbreviation,
        })
      })
    },

    loadNode(node, resolve) {
      if(node.data.id) {
        Partnership.getList({parent_id: node.data.id}, res => {
          resolve(res.data)
        })
      }
    },

    nodeExpand(data, node, obj) {
      if(this.defExpKeys.includes(node.key) == false) {
        this.defExpKeys.push(node.key)
      }
    },

    nodeCollapse(data, node) {
      let k = this.defExpKeys.indexOf(node.key)
      if(k !== -1) this.defExpKeys.splice(k, 1)
    },

    exportExcel(){
      var that=this;
      let where={};
      CommonHelp.get("Partnership/exportExcel",{},res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Partnership/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
          }else {
            this.$message(res.msg);
          }
        })
      });
    },

  }
}
</script>
<style lang="scss" scoped>

@import './common2.scss';

.area-dialog {

  .area-form {
    margin-right: 50px;
  }
}

.area-wrap {
  margin-top: 15px;
  max-width: 600px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
  overflow: auto;
  height: 600px;
}

/deep/.custom-tree-node {
  flex: 1;
  display: flex;
  justify-content: space-between;

  .area-info {
    font-size: 14px;
  }

  .area-abbreviation {
    padding-left: 5px;
    color: #999;
  }

  .area-opt {
    margin-right: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/Partnership.vue